import SpecificTriggerRules from 'modules/automation-rules/specific-trigger-rules'
import { getDefaultTriggerValue } from 'modules/automation-rules/triggers/utils/get-default-trigger-value'
import { useFunnelStepRuleData } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-rule-data'
import { useFunnelStepRules } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-rules'
import { useFunnelStepTriggers } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-triggers'
import { fillTriggerWithFunnelData } from 'modules/funnels/funnel/components/funnel-rules/utils/fill-trigger-with-funnel-data'
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header'
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum'
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { splitRelatedAndUnrelatedTriggers } from '../utils/split-related-and-unrelated-triggers'

interface AutomationRulesSectionProps {
  funnelStepId?: FunnelStepId
  funnelId: FunnelId
}

function AutomationRulesTab({ funnelId, funnelStepId }: AutomationRulesSectionProps) {
  const { t } = useLocoTranslation()
  const specificTriggerRulesData = useFunnelStepRules(funnelStepId)

  const availableTriggersData = useFunnelStepTriggers(funnelStepId)

  const { funnelTriggerData } = useFunnelStepRuleData(funnelId, funnelStepId)

  return (
    <>
      <div className="px-4 lg:hidden">
        <MobileSettingsHeader type={FunnelStepSettingTabsEnum.automationRules} />
      </div>
      <SpecificTriggerRules
        noRelatedMessage={id => (
          <TransLoco
            t={t}
            components={{
              a: (
                <LinkWithoutPrefetch href={`/automation-rules/${id}`} className={'primary-link'} />
              ),
            }}
            i18nKey={'dashboard.automation_rule.trigger.has_non_related'}
          />
        )}
        availableTriggersData={availableTriggersData}
        specificTriggerRulesData={specificTriggerRulesData}
        getRelatedAndUnrelatedTriggersData={triggers =>
          splitRelatedAndUnrelatedTriggers(triggers, funnelTriggerData?.funnelStepId)
        }
        customAddTriggerHandler={
          funnelTriggerData &&
          ((trigger, maxTriggerId) =>
            fillTriggerWithFunnelData(
              getDefaultTriggerValue(trigger, maxTriggerId),
              funnelTriggerData,
            ))
        }
      />
    </>
  )
}

export default AutomationRulesTab
